import { Action } from 'redux';

export interface State {
  isModeModal: boolean;
  isSidebarOpen: boolean;
}

export enum ActionType {
  modeModal = 'layout/modeModal',
  toggleSidebar = 'layout/toggleSidebar',
  openSidebar = 'layout/openSidebar',
}

export type ModeModalAction = Action<ActionType.modeModal> & {
  isModeModal: boolean;
};

export type ToggleSidebarAction = Action<ActionType.toggleSidebar>;
export type OpenSidebarAction = Action<ActionType.openSidebar>;

export type Actions = ModeModalAction | ToggleSidebarAction | OpenSidebarAction;
